import './CartInvalidator.scss';

import PropTypes from 'prop-types';
import React from 'react';

const goBack = () => {
    window.history.back();
};

const CartInvalidator = ({ text }) => (
    <div className="CartInvalidator">
        <div className="CartInvalidator__Content">
            <div
                className="CartInvalidator__Text"
                dangerouslySetInnerHTML={{ __html: text }}
            />
            <div className="CartInvalidator__Buttons">
                <button
                    className="CartInvalidator__Button CartInvalidator__Button--White"
                    data-response="false"
                    onClick={goBack}>
                    Stanna
                </button>
                <a className="CartInvalidator__Button CartInvalidator__Button--Blue" href="?empty_cart=yes">Fortsätt</a>
            </div>
        </div>
    </div>
);

CartInvalidator.propTypes = {
    text: PropTypes.string.isRequired,
    productId: PropTypes.string,
};

CartInvalidator.defaultProps = {};

export default CartInvalidator;
